@if (showLabel && (question?.question_copy || question?.email_version)) {
  <label class="form-group__label" [innerHtml]="question?.question_copy || question?.email_version"></label>
}

@if (!showToolTip) {
  <div class="form-group">
    <div class="autocomplete__wrap">
      @if (showLabel) {
        <label>{{isEdit ? 'What is the make of your vehicle?' : 'Make'}}</label>
      }
      <input
        type="text"
        placeholder="Make"
        [value]="make"
        [(ngModel)]="make"
        [id]="uniqueMakeControlId"
        [disabled]="readOnly"
        class="form-control form-control--autocomplete"
        autocomplete="none">
      </div>
    </div>
    <div class="form-group">
      <div class="autocomplete__wrap">
        @if (showLabel) {
          <label>{{isEdit ? 'What is the year of your vehicle?' : 'Year'}}</label>
        }
        <input
          type="number"
          placeholder="Year"
          [value]="year"
          [(ngModel)]="year"
          [id]="uniqueYearControlId"
          [disabled]="readOnly"
          class="form-control form-control--autocomplete"
          autocomplete="none">
        </div>
      </div>
      <div class="form-group">
        <div class="autocomplete__wrap">
          @if (showLabel) {
            <label>{{isEdit ? 'What is the model of your vehicle?' : 'Model'}}</label>
          }
          <input
            type="text"
            placeholder="Model"
            [value]="model"
            [(ngModel)]="model"
            [id]="uniqueModelControlId"
            [disabled]="readOnly"
            class="form-control form-control--autocomplete"
            autocomplete="none">
          </div>
        </div>
      }

      @if (showToolTip) {
        <div class="mb-30">
          @if (showLabel) {
            <label>{{isEdit ? 'What is the make of your vehicle?' : 'Make'}}</label>
          }
          <div class="input-group">
            <input
              type="text"
              placeholder="Make"
              [value]="make"
              [(ngModel)]="make"
              [id]="uniqueMakeControlId"
              [disabled]="readOnly"
              class="form-control form-control--autocomplete"
              autocomplete="none">
              <div class="input-group-append">
                <a
                  class="input-group-icon popover-trigger popover-trigger--sm"
                  tabindex="0"
                  data-toggle="popover"
                  data-trigger="focus"
                  [attr.data-html]="isToolTipContentHtml"
                  [attr.data-placement]="toolTipPlacement"
                  [attr.data-content]=toolTipContent>
                  <svg class="icon">
                    <use xlink:href="#info"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="mb-30">
            @if (showLabel) {
              <label>{{isEdit ? 'What is the year of your vehicle?' : 'Year'}}</label>
            }
            <div class="input-group">
              <input
                type="number"
                placeholder="Year"
                [value]="year"
                [(ngModel)]="year"
                [id]="uniqueYearControlId"
                [disabled]="readOnly"
                class="form-control form-control--autocomplete"
                autocomplete="none">
                <div class="input-group-append">
                  <a
                    class="input-group-icon popover-trigger popover-trigger--sm"
                    tabindex="0"
                    data-toggle="popover"
                    data-trigger="focus"
                    [attr.data-html]="isToolTipContentHtml"
                    [attr.data-placement]="toolTipPlacement"
                    [attr.data-content]=toolTipContent>
                    <svg class="icon">
                      <use xlink:href="#info"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="mb-30">
              @if (showLabel) {
                <label>{{isEdit ? 'What is the model of your vehicle?' : 'Model'}}</label>
              }
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Model"
                  [value]="model"
                  [(ngModel)]="model"
                  [id]="uniqueModelControlId"
                  [disabled]="readOnly"
                  class="form-control form-control--autocomplete"
                  autocomplete="none">
                  <div class="input-group-append">
                    <a
                      class="input-group-icon popover-trigger popover-trigger--sm"
                      tabindex="0"
                      data-toggle="popover"
                      data-trigger="focus"
                      [attr.data-html]="isToolTipContentHtml"
                      [attr.data-placement]="toolTipPlacement"
                      [attr.data-content]=toolTipContent>
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            }
